// src/hooks/useCryptoMiles.js
import { useEffect, useState } from 'react';


export default function useCryptoMiles(userId) {
  const [total, setTotal] = useState(0);
  const [pending, setPending] = useState(0);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(Boolean(userId));

  useEffect(() => {
    if (!userId) {
      setTotal(0); setPending(0); setEvents([]); setLoading(false);
      return;
    }
    setLoading(true);
    // "gasket" - to support both the regular and functional setter from the subscription
    let last = { total: 0, pending: 0, events: [] };
    
    
  }, [userId]);

  return { total, pending, events, loading };
}
